/**
 * removeFormatExtension — `removeFormat` 명령을 노출하는 NgwEditor extension (PR-N3).
 *
 * ### 배경 (D-N4 — pr-n0-inventory §3 / §3.1)
 *
 * NgwEditor 0.2.10 의 `clear-formatting` feature 는 `commands: {}` (empty 객체) 로 정의되어
 * `handle.executeCommand('removeFormat')` 호출 표면이 부재. plugins/keymap 으로만 동작하므로
 * 어댑터 측 명령 디스패치가 closed loop 를 만들 수 없다.
 *
 * 본 extension 은 `name: 'remove-format'` + `commands.removeFormat` 을 직접 등록해 NgwEditor 의
 * extension registry 를 통해 동일한 `handle.executeCommand('removeFormat')` 표면을 노출한다.
 *
 * ### 시맨틱
 *
 * - **선택 영역 비어있음**: `state.storedMarks` 만 clear → 다음 입력부터 plain text.
 * - **선택 영역 존재**: `tr.removeMark(from, to, null)` (mark=null 은 모든 mark 제거) +
 *   `setStoredMarks(null)`.
 *
 * 블록 레벨 attribute (`textAlign`, font-* 등) reset 은 본 PR 범위 외 — NgwEditor 의 schema 에
 * 어떤 block attribute 가 존재하는지에 의존하며, PR-N6 의 mail-region styling 시점에
 * 메일 도메인 요구사항이 확정된 후 보강한다. TinyMCE 의 `removeformat` 도 inline mark 중심 정리가
 * 본질이므로 PR-N3 단계의 시각 호환성은 충족 (subject 의 link/blockquote 같은 block formatting 은
 * 본 명령 대상이 아니다 — `formatting` 의 inline subset).
 *
 * ### NgwExtensionCommand 시그니처
 *
 * ProseMirror 표준 `(state, dispatch?, view?, ...args) => boolean` 형식. dispatch 가 undefined 인
 * 호출 (`canExecute` 검사용) 에서도 안전하게 boolean 만 반환 → side-effect 없이 적용 가능성만 판단.
 */

import type { NgwExtension } from '@ngweditor/react'

export const removeFormatExtension: NgwExtension = {
  name: 'remove-format',
  commands: {
    removeFormat: (state, dispatch) => {
      const { selection, tr, storedMarks } = state
      const { from, to, empty } = selection

      if (empty) {
        // 빈 선택: storedMarks 만 정리 (다음 입력부터 plain).
        if (storedMarks == null || storedMarks.length === 0) {
          return false
        }
        if (dispatch != null) {
          dispatch(tr.setStoredMarks(null))
        }
        return true
      }

      // 선택 영역의 모든 inline mark 제거 + storedMarks 정리.
      if (dispatch != null) {
        dispatch(tr.removeMark(from, to, null).setStoredMarks(null))
      }
      return true
    },
  },
}
